import { render, staticRenderFns } from "./dailySpecialGoods.vue?vue&type=template&id=eb1cfb66&scoped=true&"
import script from "./dailySpecialGoods.vue?vue&type=script&lang=js&"
export * from "./dailySpecialGoods.vue?vue&type=script&lang=js&"
import style0 from "./dailySpecialGoods.vue?vue&type=style&index=0&id=eb1cfb66&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1cfb66",
  null
  
)

export default component.exports